module.exports = __webpack_public_path__ + "media/images/athletes/546-9a49be61cd2f5ff71bc5417bca490fcf.png";